import React from 'react';
import Button from '@/components/ui/Button';

/**
 * RouteErrorBoundary Component
 * Fallback UI when a route encounters an error
 * Provides user-friendly error message and recovery action
 */
export default function RouteErrorBoundary() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center p-6">
      <div className="max-w-md space-y-4">
        <div className="text-6xl" aria-hidden="true">
          ⚠️
        </div>
        <h1 className="text-2xl font-bold text-neutral-900">Oups, une erreur est survenue</h1>
        <p className="text-neutral-600">
          Veuillez recharger la page. Si le problème persiste, contactez le support.
        </p>
        <Button onClick={() => window.location.reload()}>Recharger la page</Button>
      </div>
    </div>
  );
}
